import { render } from "./toDoItem.vue?vue&type=template&id=890d9c98&scoped=true"
import script from "./toDoItem.vue?vue&type=script&lang=js"
export * from "./toDoItem.vue?vue&type=script&lang=js"

import "./toDoItem.vue?vue&type=style&index=0&id=890d9c98&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890d9c98"]])

export default __exports__